import React from "react";
import style from "./User.scss";
export default function User({ username, color, isAdmin, currentUser }) {
  return (
    <div className={"user"} style={{ width: "87%" }}>
      <div
        className={"avatar"}
        style={{
          background: color,
          placeContent: "center",
          alignItems: "center",
        }}
      >
        {username ? username[0] : ""}
      </div>
      <div style={{ marginLeft: 45 }} className={"user_info_body"}>
        <span
          style={{ display: "table", marginTop: !isAdmin ? 13 : 0 }}
          className={"username"}
        >
          {username}
          {currentUser && " (You)"}
        </span>
        {isAdmin && <small className={"caption"}>Organizer</small>}
      </div>
    </div>
  );
}
